import { render, staticRenderFns } from "./bottomRightChart.vue?vue&type=template&id=2c6db4f4&scoped=true&"
import script from "./bottomRightChart.vue?vue&type=script&lang=js&"
export * from "./bottomRightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6db4f4",
  null
  
)

export default component.exports